/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-json-category-config.vue?vue&type=template&id=614f472e&scoped=true&"
import script from "./add-json-category-config.vue?vue&type=script&lang=js&"
export * from "./add-json-category-config.vue?vue&type=script&lang=js&"
import style0 from "./add-json-category-config.vue?vue&type=style&index=0&id=614f472e&prod&lang=scss&scoped=true&"
import style1 from "./add-json-category-config.vue?vue&type=style&index=1&id=614f472e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f472e",
  null
  
)

export default component.exports